const CryptoJS = require('crypto-js')

const aecConfig = {
	mode: CryptoJS.mode.CBC,
	padding: CryptoJS.pad.Pkcs7
}
// 加密方法
function AES_EN(text, key, iv) {
	key = CryptoJS.enc.Utf8.parse(key)
	iv = CryptoJS.enc.Utf8.parse(iv)
	const encrypted = CryptoJS.AES.encrypt(text, key, { iv, ...aecConfig })
	return encrypted.toString()
}
/**
 * 参数加密
 * @param {object} params
 */
export function encryptParams(params) {
	let timestamp = parseInt(new Date().getTime() / 1000)
	let text = JSON.stringify(params)
	let key = CryptoJS.MD5(timestamp.toString()).toString()
	let iv = key.slice(-16)
	let encrypted = AES_EN(text, key, iv)
	let wordArray = CryptoJS.enc.Utf8.parse(timestamp + '|' + encrypted)
	let result = CryptoJS.enc.Base64.stringify(wordArray)
	return result
}

export function md5Params(params) {
  const timestamp = Math.round(new Date().getTime()).toString()
  let text = JSON.stringify(params)
	let result = CryptoJS.MD5(timestamp + '|' + text).toString()
  return result
}

/**
 * @param {Array} actual
 * @returns {Array}
 */
export function cleanArray(actual) {
  const newArray = []
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i])
    }
  }
  return newArray
}
/**
 * @param {Object} json
 * @returns {String}
 */
export function paramTransfer(json) {
  if (!json) return ''
  return cleanArray(
    Object.keys(json).map(key => {
      if (json[key] === undefined) return ''
      return encodeURIComponent(key) + '=' + encodeURIComponent(json[key])
    })
  ).join('&')
}